import { ServicePartnerList } from "../components/ServicePartnerList";

export function ServicePartnerListPage(): React.ReactNode {
  return <ServicePartnerList />;
}
